import React from 'react';
import { Radio } from 'antd';

import { theme } from '../../../../styles';

import {
  Input,
  SvgIcon,
  isTinyMobile,
} from '../../ui-helpers';

import {
  SYMBOLS,
  getFontCssClass,
} from './helpers';

import {
  ItemContainer,
  Title,
  Symbols,
  StyledRadioGroup,
  FontTitleContainer,
  SymbolBtn,
  FontWrapper,
  FontContent
} from './Engraving-styled';

import { TabContainer } from '../Tab-style';


interface Props {
  engravingText: string,
  onEngravingTextChange: (value: string) => void,

  engravingFont: 'Brush Script' | 'Century Gothic' | 'Snell Roundhand' | 'Trajan' | 'Dakota',
  engravingFontOptions: ('Brush Script' | 'Century Gothic' | 'Snell Roundhand' | 'Trajan' | 'Dakota')[]
  onEngravingFontChange: (value: string) => void
}

interface State {
  engravingTextInput: string,
}

export default class extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      engravingTextInput: '',
    };

    this.onInputChange = this.onInputChange.bind(this);
    this.onSymbolSelect = this.onSymbolSelect.bind(this);
  }

  componentDidMount() {
    const {
      engravingText,
    } = this.props;

    this.setState({
      engravingTextInput: engravingText
    })   
  }

  componentDidUpdate(prevProps: Props) {
    if (prevProps.engravingText !== this.props.engravingText) {
      this.setState({
        engravingTextInput: this.props.engravingText
      })
    }
  }

  onInputChange = (value: string) => {
    this.setState({
      engravingTextInput: value,
    }, () => this.props.onEngravingTextChange(value));
  };

  onSymbolSelect = (value: string) => {
    document.getElementById('engraving-text-input').focus();
    this.setState({
      engravingTextInput: this.state.engravingTextInput.concat(value)
    }, () => this.props.onEngravingTextChange(this.state.engravingTextInput));
  };

  render() {
    const {
      engravingFont,
      onEngravingFontChange,
    } = this.props;

    const {
      engravingTextInput
    } = this.state;
    const tinyMobile = isTinyMobile();

    return (
      <div className="threed-configurator-menu-engraving-tab">
        <ItemContainer className="threed-configurator-menu-item-container" marinBtm={15}>
          <Title>Engraving Text</Title>
          <Input
            value={engravingTextInput}
            placeholder=""
            onChange={this.onInputChange}
            className={getFontCssClass(engravingFont)}
          />
        </ItemContainer>

        <ItemContainer className="threed-configurator-menu-item-container" marinBtm={30}>
          <Title>Symbols</Title>
          <Symbols>
            <SymbolBtn>
              <SvgIcon
                type="heart"
                style={{
                  width: '35%',
                  height: 'auto',
                  fill: 'inherit',
                }}
                onClick={() => this.onSymbolSelect(SYMBOLS.heart)}
              />
            </SymbolBtn>
            <SymbolBtn>
              <SvgIcon
                type="hearts"
                style={{
                  width: '40%',
                  height: 'auto',
                  fill: 'inherit',
                }}
                onClick={() => this.onSymbolSelect(SYMBOLS.couple)}
              />
            </SymbolBtn>
            <SymbolBtn isLastItem={true}>
              <SvgIcon
                type="infinity"
                style={{
                  width: '50%',
                  color: 'inherit',
                }}
                onClick={() => this.onSymbolSelect(SYMBOLS.infinity)}
              />
            </SymbolBtn>
          </Symbols>
        </ItemContainer>

        <ItemContainer className="threed-configurator-menu-item-container">
          <Title>Font</Title>
          <FontWrapper>
            {
              this.props.engravingFontOptions.map((font,index)=> <FontContent key={index} onClick={()=>onEngravingFontChange(font)}>
                  <span className={getFontCssClass(font)}>
                    Aa
                  </span>
              </FontContent>)
            }
          </FontWrapper>        
        </ItemContainer>
      </div>
    )
  }
};
